import styled from '@emotion/styled'
import { css } from '@mui/system'
import { Theme, Skeleton, Logo } from '@yuno/design-system-web'

type StyledProps = { theme?: Theme }

const ContainerStyled = styled('div')(() => ({
  width: '400px',
  height: '540px',
  boxShadow: '0 12px 40px rgba(0,0,0,0.12)',
  borderRadius: '5px',
}))

const SkeletonStyled = ({ theme }: StyledProps) => css`
  margin: 0 auto;
  transform: none;
  background-color: ${theme.palette.grey[2]};
`

const SkeletonTitleStyled = styled(Skeleton)<StyledProps>`
  ${({ theme }) => SkeletonStyled({ theme })}
  width: 138px;
  height: 19px;
`
const SkeletonSubtitleStyled = styled(Skeleton)<StyledProps>`
  ${({ theme }) => SkeletonStyled({ theme })}
  width: 133px;
  height: 19px;
  margin-top: 21px;
`
const SkeletonEmailStyled = styled(Skeleton)<StyledProps>`
  ${({ theme }) => SkeletonStyled({ theme })}
  width: 272px;
  height: 49px;
  margin-top: 14px;
`
const SkeletonPasswordStyled = styled(Skeleton)<StyledProps>`
  ${({ theme }) => SkeletonStyled({ theme })}
  width: 272px;
  height: 49px;
  margin-top: 7px;
`
const SkeletonForgotPasswordStyled = styled(Skeleton)<StyledProps>`
  background-color: ${({ theme }) => theme.palette.grey[2]};
  width: 116px;
  height: 19px;
  margin-top: 7px;
  margin-left: 64px;
`
const SkeletonButtonStyled = styled(Skeleton)<StyledProps>`
  ${({ theme }) => SkeletonStyled({ theme })}
  width: 272px;
  height: 49px;
  margin-top: 19px;
`
const SkeletonSignUpStyled = styled(Skeleton)<StyledProps>`
  background-color: ${({ theme }) => theme.palette.grey[2]};
  width: 178px;
  height: 19px;
  margin-top: 9px;
  margin-left: 64px;
`

const logoStyle = {
  width: '189px',
  height: '52px',
}

const logoContainerStyle = {
  display: 'block',
  marginLeft: '0px',
  paddingTop: '0px',
  marginTop: '40px',
  marginBottom: '40px',
  textAlign: 'center',
}

export const LoginLoading = () => {
  return (
    <ContainerStyled>
      <Logo full imgStyle={logoStyle} containerStyle={logoContainerStyle} />
      <SkeletonTitleStyled />
      <SkeletonSubtitleStyled />
      <SkeletonEmailStyled />
      <SkeletonPasswordStyled />
      <SkeletonForgotPasswordStyled />
      <SkeletonButtonStyled />
      <SkeletonSignUpStyled />
    </ContainerStyled>
  )
}
